import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { KPMGInfoIcon } from '../../assets/icons';
import InfoTooltip from '../pages/calculation/shared/InfoTooltip';
import ContentHandler from './ContentHandler';
const StyledSpan = styled.span `
  display: inline-flex;
  align-items: center;
  color: ${(props) => props.color};
  font-weight: ${props => props.bolded ? 'bold' : 'normal'};
`;
const Label = ({ title, titleRelatedData, titleFormatter = title => title, color, className, bolded, automationId, labelInfo = '' }) => {
    const { t: translate } = useTranslation();
    return (<StyledSpan className={className} color={color} bolded={bolded} data-automation-id={automationId}>
      {titleFormatter(translate(title, titleRelatedData))}
      <ContentHandler shouldDisplayContent={labelInfo !== ''} render={() => (<InfoTooltip text={translate(labelInfo)} getPopupContainer={triggerNode => triggerNode}>
          <KPMGInfoIcon />
        </InfoTooltip>)}/>
    </StyledSpan>);
};
export default Label;
